import React, { useEffect, useState } from 'react';
import { Loader2, Coffee, LogIn } from 'lucide-react';

// Popup automatico pausa pranzo (13:00) e rientro (14:00) — orari presi dalle fasce personali.
// Se ignorato, la pausa viene comunque registrata automaticamente dal backend.
export const LunchPopup = ({ me, busy, onPunch }) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick(x => x + 1), 30000);
    return () => clearInterval(t);
  }, []);

  if (!me?.has_passkey || me.absence_today) return null;
  const ranges = me.today_ranges || [];
  const next = me.next || {};
  if (ranges.length < 2) return null;

  const hhmm = new Date().toTimeString().slice(0, 5);
  let kind = null;
  if (next.action === 'out' && next.range_index === 0 && hhmm >= ranges[0][1]) kind = 'pausa';
  else if (next.action === 'in' && next.range_index === 1 && hhmm >= ranges[1][0]) kind = 'rientro';
  if (!kind) return null;

  const key = `hr_lunch_${me.today?.day}_${kind}`;
  if (localStorage.getItem(key)) return null;
  const dismiss = () => { localStorage.setItem(key, '1'); setTick(x => x + 1); };
  const punch = async () => { localStorage.setItem(key, '1'); await onPunch(next.action); };

  const isPausa = kind === 'pausa';
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-6" data-testid="hr-lunch-popup">
      <div className="bg-slate-800 border border-slate-600 rounded-2xl p-6 max-w-sm w-full text-center space-y-4 text-white shadow-2xl">
        <p className="text-4xl">{isPausa ? '🍽️' : '⏰'}</p>
        <h2 className="text-xl font-bold" data-testid="hr-lunch-popup-title">
          {isPausa ? `Sono le ${ranges[0][1]} — è ora di pausa!` : `Sono le ${ranges[1][0]} — rientro dalla pausa!`}
        </h2>
        <p className="text-sm text-slate-400">
          {isPausa
            ? `Timbra la pausa adesso. Se non timbri, la pausa verrà registrata comunque in automatico alle ${ranges[0][1]}.`
            : 'Timbra il rientro per registrare il pomeriggio.'}
        </p>
        <button data-testid="hr-lunch-punch-btn" disabled={busy} onClick={punch}
          className={`w-full h-12 rounded-xl font-bold flex items-center justify-center gap-2 transition-transform active:scale-95 ${isPausa ? 'bg-amber-600 hover:bg-amber-500' : 'bg-emerald-600 hover:bg-emerald-500'}`}>
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : (isPausa ? <Coffee className="h-5 w-5" /> : <LogIn className="h-5 w-5" />)}
          {isPausa ? 'Timbra pausa ora' : 'Timbra rientro ora'}
        </button>
        <button data-testid="hr-lunch-dismiss-btn" onClick={dismiss} className="text-sm text-slate-400 hover:text-slate-200">
          Più tardi
        </button>
      </div>
    </div>
  );
};
